<div class="flex flex-col gap-2 min-h-0 overflow-y-auto mb-2">
  @if (authenticated()) {
    <!-- Process settings -->
    <kfm-card [cardTitle]="processCardTitle" [cardIcon]="processIcon">
      <ng-container
        *ngTemplateOutlet="
          optionCheckTemplate;
          context: {
            title: processClosedItemTitle,
            subtitle: processClosedItemSubtitle,
            model: settings.showClosed,
            name: 'showClosed',
          }
        "
      ></ng-container>

      <hs-divider></hs-divider>

      <ng-container
        *ngTemplateOutlet="
          optionCheckTemplate;
          context: {
            title: processAccomplishedItemTitle,
            subtitle: processAccomplishedItemSubtitle,
            model: settings.showAccomplished,
            name: 'showAccomplished',
          }
        "
      ></ng-container>
    </kfm-card>

    <!-- Article settings -->
    <kfm-card
      [cardTitle]="articleCardTitle"
      [cardIcon]="processIcon"
      [hsLayer]="'two'"
    >
      <ng-container
        *ngTemplateOutlet="
          optionCheckTemplate;
          context: {
            title: articlePriceItemTitle,
            subtitle: articlePriceItemSubtitle,
            model: settings.showPrice,
            name: 'showPrice',
          }
        "
      ></ng-container>

      <hs-divider></hs-divider>

      <ng-container
        *ngTemplateOutlet="
          optionSelectTemplate;
          context: {
            title: articleMwstItemTitle,
            subtitle: articleMwstItemSubtitle,
            placeholder: articleMwstLabel,
            options: articleMwstOptions,
            model: settings.mwst + '%',
            name: 'mwst',
          }
        "
      ></ng-container>

      <hs-divider></hs-divider>

      <ng-container
        *ngTemplateOutlet="
          optionCheckTemplate;
          context: {
            title: articleImageItemTitle,
            subtitle: articleImageItemSubtitle,
            model: settings.showStockImage,
            name: 'showStockImage',
          }
        "
      ></ng-container>

      <hs-divider></hs-divider>

      <ng-container
        *ngTemplateOutlet="
          optionClickTemplate;
          context: {
            title: articleImportItemTitle,
            subtitle: articleImportItemSubtitle,
            icon: chevronRightIcon,
            name: 'articleImport',
            tabindex: 0,
          }
        "
      ></ng-container>
    </kfm-card>
  }

  <!-- Help setting -->
  <kfm-card [cardTitle]="helpCardTitle" [cardIcon]="helpIcon">
    @if (authenticated()) {
      <ng-container
        *ngTemplateOutlet="
          optionClickTemplate;
          context: {
            title: helpDeleteDataItemTitle,
            subtitle: helpDeleteDataItemSubtitle,
            icon: chevronRightIcon,
            name: 'helpDeleteData',
            tabindex: 1,
          }
        "
      ></ng-container>

      <hs-divider></hs-divider>
    }

    <ng-container
      *ngTemplateOutlet="
        optionClickTemplate;
        context: {
          title: helpCommonItemTitle,
          subtitle: helpCommonItemSubtitle,
          icon: openExternalIcon,
          name: 'helpCommon',
          tabindex: 2,
        }
      "
    ></ng-container>

    <hs-divider></hs-divider>

    <ng-container
      *ngTemplateOutlet="
        optionClickTemplate;
        context: {
          title: helpSupportItemTitle,
          subtitle: helpSupportItemSubtitle,
          icon: openExternalIcon,
          name: 'helpSupport',
          tabindex: 3,
        }
      "
    ></ng-container>
  </kfm-card>

  <!-- Info setting -->
  <kfm-card [cardTitle]="infoCardTitle" [cardIcon]="infoIcon" class="mb-2">
    <ng-container
      *ngTemplateOutlet="
        optionTemplate;
        context: {
          title: infoVersionItemTitle,
          subtitle: infoVersionItemSubtitle,
        }
      "
    ></ng-container>

    <hs-divider></hs-divider>

    <ng-container
      *ngTemplateOutlet="
        optionClickTemplate;
        context: {
          title: infoNewItemTitle,
          subtitle: infoNewItemSubtitle,
          icon: openExternalIcon,
          name: 'infoNew',
          tabindex: 4,
        }
      "
    ></ng-container>

    <hs-divider></hs-divider>

    <ng-container
      *ngTemplateOutlet="
        optionClickTemplate;
        context: {
          title: infoDataProtectionItemTitle,
          subtitle: infoDataProtectionItemSubtitle,
          icon: openExternalIcon,
          name: 'infoDataProtection',
          tabindex: 5,
        }
      "
    ></ng-container>

    <hs-divider></hs-divider>

    <ng-container
      *ngTemplateOutlet="
        optionClickTemplate;
        context: {
          title: infoUsageConditionsItemTitle,
          subtitle: infoUsageConditionsItemSubtitle,
          icon: openExternalIcon,
          name: 'infoUsageConditions',
          tabindex: 6,
        }
      "
    ></ng-container>

    <hs-divider></hs-divider>

    <ng-container
      *ngTemplateOutlet="
        optionClickTemplate;
        context: {
          title: infoTeamViewerItemTitle,
          subtitle: infoTeamViewerItemSubtitle,
          icon: openExternalIcon,
          name: 'infoTeamViewer',
          tabindex: 7,
        }
      "
    ></ng-container>
  </kfm-card>
</div>

<span class="flex-1"></span>

<div class="flex flex-row w-full justify-end gap-2 p-2">
  <button
    hsButton
    hsButtonSize="sm"
    hsButtonVariant="filled"
    (click)="dialogRef.close()"
  >
    {{ okButtonLabel }}
  </button>
</div>

<ng-template #optionTemplate let-title="title" let-subtitle="subtitle">
  <div class="flex flex-row w-full gap-4 items-center">
    <div class="flex flex-col flex-1 min-w-0">
      <span class="font-bold">{{ title }}</span>
      <span class="text-sm truncate">{{ subtitle }}</span>
    </div>
  </div>
</ng-template>

<ng-template
  #optionCheckTemplate
  let-title="title"
  let-subtitle="subtitle"
  let-model="model"
  let-name="name"
>
  <div class="flex flex-row w-full gap-4 items-center">
    <div class="flex flex-col flex-1 min-w-0">
      <span class="font-bold">{{ title }}</span>
      <span class="text-sm truncate">{{ subtitle }}</span>
    </div>
    <div class="w-6 h-6 shrink-0">
      <input
        type="checkbox"
        [id]="name"
        [name]="name"
        class="w-full h-full"
        [checked]="model"
        (change)="onCheckChanged($event, name)"
      />
    </div>
  </div>
</ng-template>

<ng-template
  #optionSelectTemplate
  let-title="title"
  let-subtitle="subtitle"
  let-placeholder="placeholder"
  let-options="options"
  let-model="model"
  let-name="name"
>
  <div class="flex flex-row w-full gap-4 items-center">
    <div class="flex flex-col flex-1 min-w-0">
      <span class="font-bold">{{ title }}</span>
      <span class="text-sm truncate">{{ subtitle }}</span>
    </div>
    <div class="w-35 shrink-0">
      <hs-form-field class="w-full">
        <hs-form-label>{{ placeholder }}</hs-form-label>
        <hs-select
          [options]="options"
          [selectedValue]="model"
          (selectionChanged)="onSelectionChanged($event, name)"
        ></hs-select>
      </hs-form-field>
    </div>
  </div>
</ng-template>

<ng-template
  #optionClickTemplate
  let-title="title"
  let-subtitle="subtitle"
  let-icon="icon"
  let-name="name"
  let-tabindex="tabindex"
>
  <div
    type="button"
    [tabindex]="tabindex ? tabindex : 0"
    (keydown.enter)="onButtonClicked(name)"
    class="flex flex-row w-full gap-4 items-center cursor-pointer opacity-100 hover:opacity-60 transition-opacity"
    (click)="onButtonClicked(name)"
  >
    <div class="flex flex-col flex-1 min-w-0">
      <span class="font-bold">{{ title }}</span>
      <span class="text-sm truncate">{{ subtitle }}</span>
    </div>
    <hs-icon [width]="16" [height]="16" [innerHTML]="icon"></hs-icon>
  </div>
</ng-template>
